<div class="container-fluid">
  <div class="row no-gutters">
    <div class="col-xs-12 col-lg-4 vcenter">
      <h3 class="page-header">{{headerText}}</h3>
    </div>
    <div class="col-xs-12 col-lg-8 top10 vcenter-right">
      <b>Print History:&nbsp;&nbsp;</b>
      <div class="btn-group" role="group" aria-label="...">
        <button *ngIf="(routedFrom == 'employeeTraining')"
                type="button"
                class="btn btn-default btn-sm"
                (click)="printAllHistory(empId)">
          <i class="fas fa-print"></i>&nbsp;All
        </button>
        <button type="button"
                class="btn btn-default btn-sm"
                (click)="printCurrentHistory(empId)">
          <i class="fas fa-print"></i>&nbsp;Current
        </button>
        <button *ngIf="(hasJtRequirements && countOccs > 1)"
                type="button"
                class="btn btn-default btn-sm"
                (click)="printOccJobTitleHistory(empId)">
          <i class="fas fa-print"></i>&nbsp;Req'd by OCC Job Title(s)
        </button>
        <button type="button"
                class="btn btn-default btn-sm"
                (click)="printMyOverdueOrComingDueTraining(empId)">
          <i class="fas fa-print"></i>&nbsp;Over/Coming Due
        </button>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="row" *ngIf="(permissions.canRead(permissions.ComponentID.EmployeeTraining) && routedFrom == 'employeeTraining')">
      <div class="col-xs-1 text-right">
        <label for="dropdownlist">Select Employee:</label>
      </div>
      <div class="col-xs-2">
        <mat-form-field appearance="fill">
          <mat-select
              [(ngModel)]="empId"
              name="Employee"
              (selectionChange)="empTrainingReview($event.value)"
              required >
            <mat-option *ngFor="let e of employeeValues" [value]="e.employeeId"> {{e.fullName}} </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-xs-3">
        <label>Active and EOA only?:&nbsp;&nbsp;</label>
        <mat-checkbox appearance="fill"
               name="Active and EOA only"
               [(ngModel)]="isActiveAndEOAOnly"
               (change)="handleActiveAndEOAOnlyChecked()" ></mat-checkbox>
      </div>
    </div>

    <div class="row" *ngIf="(permissions.canRead(permissions.ComponentID.EmployeeTraining) && routedFrom == 'employeeTraining')">
      <div class="col-xs-12">
        <div class="row">

          <div class="col-xs-1 top10 text-right">
            <b>Permanent Site:</b>
          </div>
          <div class="col-xs-2 top10">
            {{ empForTraining.permanentSiteId | getText:'siteId':'siteCode':siteValues }}
          </div>

          <div class="col-xs-1 top10 text-right">
            <b>Clearance Status:</b>
          </div>
          <div class="col-xs-2 top10">
            {{ empForTraining.clearanceStatus }}&nbsp;as of
            {{ empForTraining.clearanceDate  | date:'MM/dd/yyyy'}}
          </div>

          <div class="col-xs-1 top10 text-right" *ngIf="empForTraining.homePhone != null">
            <b>Primary Contact:</b>
          </div>
          <div class="col-xs-2 top10">
            {{ empForTraining.homePhone }}
          </div>

          <div class="col-xs-1 top10 text-right" *ngIf="empForTraining.messagePhone != null">
            <b>Alternate Contact:</b>
          </div>
          <div class="col-xs-2 top10">
            {{ empForTraining.messagePhone }}
          </div>
        </div>
      </div>
    </div>

    <div class="row" *ngIf="(permissions.canRead(permissions.ComponentID.EmployeeTraining) && routedFrom == 'employeeTraining')">
      <div class="col-xs-12">
        <div class="row">

          <div class="col-xs-1 top10 text-right">
            <b>Department:</b>
          </div>
          <div class="col-xs-2 top10">
            {{ empForTraining.departmentId | getText:'departmentId':'department':departmentValues | async }}
          </div>

          <div class="col-xs-1 top10 text-right">
            <b>WorkSection:</b>
          </div>
          <div class="col-xs-2 top10">
            {{ empForTraining.workSectionId | getText:'workSectionId':'workSection':workSectionValues | async }}
          </div>

          <div class="col-xs-1 top10 text-right">
            <b>Job Title:</b>
          </div>
          <div class="col-xs-2 top10">
            {{ empForTraining.titleId | getText:'jobTitleId':'jobTitle':jobTitleValues | async }}
          </div>

          <div class="col-xs-1 top10 text-right">
            <b>Job Assignment:</b>
          </div>
          <div class="col-xs-2 top10">
            {{ empForTraining.employeeJobAssignmentId | getText:'employeeJobAssignmentId':'assignmentDescription':jobAssignmentValues | async }}
          </div>
        </div>
      </div>
    </div>

    <div class="row colorSection">
      <div class="col-xs-12 text-left">
        <h4>
          <strong><u>Individually Assigned</u>&nbsp;&nbsp;  </strong><input style="width: 13px" type="checkbox" name="showIndAssigned" [(ngModel)]="showIndAssigned" tabindex="-1" />
        </h4>
      </div>
    </div>

    <div class="row" *ngIf="showIndAssigned">
      <div class="col-xs-12">
        <aims-common-table
                    id="ind-assigned-table"
                    [dataSource]="indAssignedTraining | async"
                    [header]="qualificationTableHeader"
                    [permissions]="qualificationTablePermissions"
                    pageSize="10"
                    [stickyHeader]="true">

        <aims-common-table-dynamic-row id="buttons">
          <ng-template viewMode let-element >
            <aims-common-button-mini
                  *ngIf="permissions.canUpdate(permissions.ComponentID.EmployeeTraining) && routedFrom == 'employeeTraining' && !isMyTraining"
                  (click)="updateQualRequired(element, INDIVIDUALLY_ASSIGNED)"
                  title="Toggle Required"
                  aria-label="Toggle Required">
               <span class="primary-text"> {{ (element.qualRequired) ? '-Req' : '+Req' }}</span>
            </aims-common-button-mini>

            <aims-common-button-mini
                  *ngIf="permissions.canUpdate(permissions.ComponentID.QualApproval) &&
                    element.qualActive &&
                    routedFrom == 'employeeTraining' &&
                    !isMyTraining &&
                    !(element.qualHistory === undefined || element.qualHistory.length == 0) &&
                    element.qualHistory[0].approvedBy != null"
                  (click)="openRevokeApprovalComment(element, INDIVIDUALLY_ASSIGNED)"
                  title="Revoke Approval"
                  aria-label="Revoke Approval">
               <span class="primary-text">Rev</span>
            </aims-common-button-mini>
          </ng-template>
        </aims-common-table-dynamic-row>

        <aims-common-table-dynamic-row id="approvedOn">
          <ng-template viewMode let-element >
              {{(element.qualHistory === undefined || element.qualHistory.length == 0) ? "" : element.qualHistory[0].approvedOn | date:'MM/dd/yyyy'}}
          </ng-template>
        </aims-common-table-dynamic-row>

        <aims-common-table-dynamic-row id="approvedBy">
          <ng-template viewMode let-element >
              {{(element.qualHistory === undefined || element.qualHistory.length == 0) ? "" : element.qualHistory[0].approvedBy}}
          </ng-template>
        </aims-common-table-dynamic-row>

        <aims-common-table-dynamic-row id="revokedOn">
          <ng-template viewMode let-element >
              {{(element.qualHistory === undefined || element.qualHistory.length == 0) ? "" : element.qualHistory[0].revokedOn | date:'MM/dd/yyyy'}}
          </ng-template>
        </aims-common-table-dynamic-row>

        <aims-common-table-dynamic-row id="revokedBy">
          <ng-template viewMode let-element >
              {{(element.qualHistory === undefined || element.qualHistory.length == 0) ? "" : element.qualHistory[0].revokedBy }}
          </ng-template>
        </aims-common-table-dynamic-row>

        <ng-template aimsCommonTableExpandedRow let-element >
          <div style="flex-wrap: wrap; width:100%">
            <div class="col-md-6" *ngIf="element.qualId != 0" style="width: 100%;">
              <aims-common-table
                    id="ind-assigned-sub-table"
                    [dataSource]="element.qtDetail"
                    [header]="qualificationSubTableHeader"
                    [permissions]="qualificationSubTablePermissions"
                    pageSize="5"
                    [stickyHeader]="true">

                <aims-common-table-dynamic-row id="buttons">
                  <ng-template viewMode let-element >
                    <aims-common-button-mini
                          *ngIf="permissions.canUpdate(permissions.ComponentID.EmployeeTraining) && routedFrom == 'employeeTraining' && !isMyTraining"
                          (click)="updateQtRequired(element, INDIVIDUALLY_ASSIGNED)"
                          title="Toggle Required"
                          aria-label="Toggle Required">
                       <span class="primary-text"> {{ (element.qtRequired) ? '-Req' : '+Req' }}</span>
                    </aims-common-button-mini>

                    <aims-common-button-mini *ngIf="permissions.canUpdate(permissions.ComponentID.EmployeeTraining) &&
                                element.qtActive &&
                                routedFrom == 'employeeTraining' &&
                                !isMyTraining &&
                                !element.qtHistory?.revoked &&
                                element.qtHistory?.completedOn != null"
                          (click)="openRevokeComment(element, INDIVIDUALLY_ASSIGNED)"
                          title="Revoke"
                          aria-label="Revoke">
                       <span class="primary-text">Rev</span>
                    </aims-common-button-mini>

                    <aims-common-button-mini *ngIf="(tFunc.canUpdateTraining(element) &&
                              ( (permissions.canUpdate(permissions.ComponentID.EmployeeTraining) && routedFrom == 'employeeTraining' && !isMyTraining) ||
                                (permissions.canUpdate(permissions.ComponentID.MyTraining) && routedFrom == 'myTraining')))"
                              (click)="updateTraining(element, INDIVIDUALLY_ASSIGNED)"
                          title="Update"
                          aria-label="Update">
                       <span class="primary-text">Upd</span>
                    </aims-common-button-mini>

                  </ng-template>
                </aims-common-table-dynamic-row>

                <aims-common-table-dynamic-row id="qualTaskUrlLink">
                  <ng-template viewMode let-element >
                    <a *ngIf="element.qualTaskUrlLink != null && element.qualTaskUrlLink.length > 1" target="_blank" style="color:blue" href="{{element.qualTaskUrlLink}}">Go To</a>
                  </ng-template>
                </aims-common-table-dynamic-row>

                <aims-common-table-dynamic-row id="revokedReason">
                  <ng-template viewMode let-element >
                      {{element.qtHistory?.revokedReason}}
                  </ng-template>
                </aims-common-table-dynamic-row>

                <aims-common-table-dynamic-row id="completedOn">
                  <ng-template viewMode let-element >
                    <span class="whole-cell" [ngStyle]="tFunc.colorDate(element.qtHistory?.completedOn, element.intervalInMonths )">
                        {{element.qtHistory?.completedOn | date:'MM/dd/yyyy'}}
                      </span>
                  </ng-template>
                </aims-common-table-dynamic-row>

                <aims-common-table-dynamic-row id="trainedBy">
                  <ng-template viewMode let-element >
                      {{element.qtHistory?.trainedBy}}
                  </ng-template>
                </aims-common-table-dynamic-row>

                <aims-common-table-dynamic-row id="certifiedBy">
                  <ng-template viewMode let-element >
                      {{element.qtHistory?.certifiedBy}}
                  </ng-template>
                </aims-common-table-dynamic-row>
              </aims-common-table>
            </div>
          </div>
        </ng-template>
      </aims-common-table>
      </div>
    </div>

    <hr style="margin-top:2px;margin-bottom:2px" />

    <div class="row colorSection">
      <div class="col-xs-12 text-left">
        <h4>
          <strong><u>General</u>&nbsp;&nbsp;  </strong><input style="width: 13px" type="checkbox" name="showGenAssigned" [(ngModel)]="showGenAssigned" tabindex="-1" />
        </h4>
      </div>
    </div>

    <div class="row" *ngIf="showGenAssigned">
      <div class="col-xs-12">
        <aims-common-table
          id="general-table"
          [dataSource]="generalTraining | async"
          [header]="qualificationTableHeader"
          [permissions]="qualificationTablePermissions"
          pageSize="10"
          [stickyHeader]="true">

          <aims-common-table-dynamic-row id="buttons">
            <ng-template viewMode let-element >
              <aims-common-button-mini
                  *ngIf="permissions.canUpdate(permissions.ComponentID.EmployeeTraining) && routedFrom == 'employeeTraining' && !isMyTraining"
                  (click)="updateQualRequired(element, GENERAL)"
                  title="Toggle Required"
                  aria-label="Toggle Required">
                <span class="primary-text"> {{ (element.qualRequired) ? '-Req' : '+Req' }}</span>
              </aims-common-button-mini>

              <aims-common-button-mini
                  *ngIf="permissions.canUpdate(permissions.ComponentID.QualApproval) &&
                    element.qualActive &&
                    routedFrom == 'employeeTraining' &&
                    !isMyTraining &&
                    !(element.qualHistory === undefined || element.qualHistory.length == 0) &&
                    element.qualHistory[0].approvedBy != null"
                  (click)="openRevokeApprovalComment(element, GENERAL)"
                  title="Revoke Approval"
                  aria-label="Revoke Approval">
                <span class="primary-text">Rev</span>
            </aims-common-button-mini>
          </ng-template>
        </aims-common-table-dynamic-row>

        <aims-common-table-dynamic-row id="approvedOn">
          <ng-template viewMode let-element >
              {{(element.qualHistory === undefined || element.qualHistory.length == 0) ? "" : element.qualHistory[0].approvedOn | date:'MM/dd/yyyy'}}
          </ng-template>
        </aims-common-table-dynamic-row>

        <aims-common-table-dynamic-row id="approvedBy">
          <ng-template viewMode let-element >
              {{(element.qualHistory === undefined || element.qualHistory.length == 0) ? "" : element.qualHistory[0].approvedBy}}
          </ng-template>
        </aims-common-table-dynamic-row>

        <aims-common-table-dynamic-row id="revokedOn">
          <ng-template viewMode let-element >
              {{(element.qualHistory === undefined || element.qualHistory.length == 0) ? "" : element.qualHistory[0].revokedOn | date:'MM/dd/yyyy'}}
          </ng-template>
        </aims-common-table-dynamic-row>

        <aims-common-table-dynamic-row id="revokedBy">
          <ng-template viewMode let-element >
              {{(element.qualHistory === undefined || element.qualHistory.length == 0) ? "" : element.qualHistory[0].revokedBy }}
          </ng-template>
        </aims-common-table-dynamic-row>

        <ng-template aimsCommonTableExpandedRow let-element >
          <div style="flex-wrap: wrap; width:100%">
            <div class="col-md-6" style="width: 100%;">
              <aims-common-table
                    id="general-sub-table"
                    [dataSource]="element.qtDetail"
                    [header]="qualificationSubTableHeader"
                    [permissions]="qualificationSubTablePermissions"
                    pageSize="5"
                    [stickyHeader]="true">

                <aims-common-table-dynamic-row id="buttons">
                  <ng-template viewMode let-element >
                    <aims-common-button-mini
                          *ngIf="permissions.canUpdate(permissions.ComponentID.EmployeeTraining) && routedFrom == 'employeeTraining' && !isMyTraining"
                          (click)="updateQtRequired(element, GENERAL)"
                          title="Toggle Required"
                          aria-label="Toggle Required">
                       <span class="primary-text"> {{ (element.qtRequired) ? '-Req' : '+Req' }}</span>
                    </aims-common-button-mini>

                    <aims-common-button-mini *ngIf="permissions.canUpdate(permissions.ComponentID.EmployeeTraining) &&
                                element.qtActive &&
                                routedFrom == 'employeeTraining' &&
                                !isMyTraining &&
                                !element.qtHistory?.revoked &&
                                element.qtHistory?.completedOn != null"
                          (click)="openRevokeComment(element, GENERAL)"
                          title="Revoke"
                          aria-label="Revoke">
                       <span class="primary-text">Rev</span>
                    </aims-common-button-mini>

                    <aims-common-button-mini *ngIf="(tFunc.canUpdateTraining(element) &&
                              ( (permissions.canUpdate(permissions.ComponentID.EmployeeTraining) && routedFrom == 'employeeTraining' && !isMyTraining) ||
                                (permissions.canUpdate(permissions.ComponentID.MyTraining) && routedFrom == 'myTraining')))"
                              (click)="updateTraining(element, GENERAL)"
                          title="Update"
                          aria-label="Update">
                       <span class="primary-text">Upd</span>
                    </aims-common-button-mini>

                  </ng-template>
                </aims-common-table-dynamic-row>

                <aims-common-table-dynamic-row id="qualTaskUrlLink">
                  <ng-template viewMode let-element >
                    <a *ngIf="element.qualTaskUrlLink != null && element.qualTaskUrlLink.length > 1" target="_blank" style="color:blue" href="{{element.qualTaskUrlLink}}">Go To</a>
                  </ng-template>
                </aims-common-table-dynamic-row>

                <aims-common-table-dynamic-row id="revokedReason">
                  <ng-template viewMode let-element >
                      {{element.qtHistory?.revokedReason}}
                  </ng-template>
                </aims-common-table-dynamic-row>

                <aims-common-table-dynamic-row id="completedOn">
                  <ng-template viewMode let-element >
                    <span class="whole-cell" [ngStyle]="tFunc.colorDate(element.qtHistory?.completedOn, element.intervalInMonths )">
                        {{element.qtHistory?.completedOn | date:'MM/dd/yyyy'}}
                      </span>
                  </ng-template>
                </aims-common-table-dynamic-row>

                <aims-common-table-dynamic-row id="trainedBy">
                  <ng-template viewMode let-element >
                      {{element.qtHistory?.trainedBy}}
                  </ng-template>
                </aims-common-table-dynamic-row>

                <aims-common-table-dynamic-row id="certifiedBy">
                  <ng-template viewMode let-element >
                      {{element.qtHistory?.certifiedBy}}
                  </ng-template>
                </aims-common-table-dynamic-row>
              </aims-common-table>
            </div>
          </div>
        </ng-template>
        </aims-common-table>
      </div>
    </div>

    <hr style="margin-top:2px;margin-bottom:2px" />

    <div class="row colorSection">
      <div class="col-xs-12 text-left">
        <h4>
          <strong><u>Current Job Title</u>&nbsp;&nbsp;  </strong><input style="width: 13px" type="checkbox" name="showJtAssigned" [(ngModel)]="showJtAssigned" tabindex="-1" />
        </h4>
      </div>
    </div>

    <div class="row" *ngIf="showJtAssigned">
      <div class="col-xs-12">

        <aims-common-table
          id="job-training-table"
          [dataSource]="jobTitleTraining | async"
          [header]="qualificationTableHeader"
          [permissions]="qualificationTablePermissions"
          pageSize="10"
          [stickyHeader]="true">

          <aims-common-table-dynamic-row id="buttons">
            <ng-template viewMode let-element >
              <aims-common-button-mini
                  *ngIf="permissions.canUpdate(permissions.ComponentID.EmployeeTraining) && routedFrom == 'employeeTraining' && !isMyTraining"
                  (click)="updateQualRequired(element, JOB_TITLE)"
                  title="Toggle Required"
                  aria-label="Toggle Required">
                <span class="primary-text"> {{ (element.qualRequired) ? '-Req' : '+Req' }}</span>
              </aims-common-button-mini>

              <aims-common-button-mini
                  *ngIf="permissions.canUpdate(permissions.ComponentID.QualApproval) &&
                    element.qualActive &&
                    routedFrom == 'employeeTraining' &&
                    !isMyTraining &&
                    !(element.qualHistory === undefined || element.qualHistory.length == 0) &&
                    element.qualHistory[0].approvedBy != null"
                  (click)="openRevokeApprovalComment(element, JOB_TITLE)"
                  title="Revoke Approval"
                  aria-label="Revoke Approval">
                <span class="primary-text">Rev</span>
            </aims-common-button-mini>
          </ng-template>
        </aims-common-table-dynamic-row>

        <aims-common-table-dynamic-row id="approvedOn">
          <ng-template viewMode let-element >
              {{(element.qualHistory === undefined || element.qualHistory.length == 0) ? "" : element.qualHistory[0].approvedOn | date:'MM/dd/yyyy'}}
          </ng-template>
        </aims-common-table-dynamic-row>

        <aims-common-table-dynamic-row id="approvedBy">
          <ng-template viewMode let-element >
              {{(element.qualHistory === undefined || element.qualHistory.length == 0) ? "" : element.qualHistory[0].approvedBy}}
          </ng-template>
        </aims-common-table-dynamic-row>

        <aims-common-table-dynamic-row id="revokedOn">
          <ng-template viewMode let-element >
              {{(element.qualHistory === undefined || element.qualHistory.length == 0) ? "" : element.qualHistory[0].revokedOn | date:'MM/dd/yyyy'}}
          </ng-template>
        </aims-common-table-dynamic-row>

        <aims-common-table-dynamic-row id="revokedBy">
          <ng-template viewMode let-element >
              {{(element.qualHistory === undefined || element.qualHistory.length == 0) ? "" : element.qualHistory[0].revokedBy }}
          </ng-template>
        </aims-common-table-dynamic-row>

        <ng-template aimsCommonTableExpandedRow let-element >
          <div style="flex-wrap: wrap; width:100%">
            <div class="col-md-6" style="width: 100%;">
              <aims-common-table
                    id="general-sub-table"
                    [dataSource]="element.qtDetail"
                    [header]="qualificationSubTableHeader"
                    [permissions]="qualificationSubTablePermissions"
                    pageSize="5"
                    [stickyHeader]="true">

                <aims-common-table-dynamic-row id="buttons">
                  <ng-template viewMode let-element >
                    <aims-common-button-mini
                          *ngIf="permissions.canUpdate(permissions.ComponentID.EmployeeTraining) && routedFrom == 'employeeTraining' && !isMyTraining"
                          (click)="updateQtRequired(element, JOB_TITLE)"
                          title="Toggle Required"
                          aria-label="Toggle Required">
                       <span class="primary-text"> {{ (element.qtRequired) ? '-Req' : '+Req' }}</span>
                    </aims-common-button-mini>

                    <aims-common-button-mini *ngIf="permissions.canUpdate(permissions.ComponentID.EmployeeTraining) &&
                                element.qtActive &&
                                routedFrom == 'employeeTraining' &&
                                !isMyTraining &&
                                !element.qtHistory?.revoked &&
                                element.qtHistory?.completedOn != null"
                          (click)="openRevokeComment(element, JOB_TITLE)"
                          title="Revoke"
                          aria-label="Revoke">
                       <span class="primary-text">Rev</span>
                    </aims-common-button-mini>

                    <aims-common-button-mini *ngIf="(tFunc.canUpdateTraining(element) &&
                              ( (permissions.canUpdate(permissions.ComponentID.EmployeeTraining) && routedFrom == 'employeeTraining' && !isMyTraining) ||
                                (permissions.canUpdate(permissions.ComponentID.MyTraining) && routedFrom == 'myTraining')))"
                              (click)="updateTraining(element, JOB_TITLE)"
                          title="Update"
                          aria-label="Update">
                       <span class="primary-text">Upd</span>
                    </aims-common-button-mini>

                  </ng-template>
                </aims-common-table-dynamic-row>

                <aims-common-table-dynamic-row id="qualTaskUrlLink">
                  <ng-template viewMode let-element >
                    <a *ngIf="element.qualTaskUrlLink != null && element.qualTaskUrlLink.length > 1" target="_blank" style="color:blue" href="{{element.qualTaskUrlLink}}">Go To</a>
                  </ng-template>
                </aims-common-table-dynamic-row>

                <aims-common-table-dynamic-row id="revokedReason">
                  <ng-template viewMode let-element >
                      {{element.qtHistory?.revokedReason}}
                  </ng-template>
                </aims-common-table-dynamic-row>

                <aims-common-table-dynamic-row id="completedOn">
                  <ng-template viewMode let-element >
                    <span class="whole-cell" [ngStyle]="tFunc.colorDate(element.qtHistory?.completedOn, element.intervalInMonths )">
                        {{element.qtHistory?.completedOn | date:'MM/dd/yyyy'}}
                      </span>
                  </ng-template>
                </aims-common-table-dynamic-row>

                <aims-common-table-dynamic-row id="trainedBy">
                  <ng-template viewMode let-element >
                      {{element.qtHistory?.trainedBy}}
                  </ng-template>
                </aims-common-table-dynamic-row>

                <aims-common-table-dynamic-row id="certifiedBy">
                  <ng-template viewMode let-element >
                      {{element.qtHistory?.certifiedBy}}
                  </ng-template>
                </aims-common-table-dynamic-row>
              </aims-common-table>
            </div>
          </div>
        </ng-template>
        </aims-common-table>

      </div>
    </div>
    <hr style="margin-top:2px;margin-bottom:2px" />

    <div class="row colorSection">
      <div class="col-xs-12 text-left">
        <h4>
          <strong><u>Other Job Title(s)</u>&nbsp;&nbsp;  </strong><input style="width: 13px" type="checkbox" name="showOjtAssigned" [(ngModel)]="showOjtAssigned" tabindex="-1" />
        </h4>
      </div>
    </div>

    <div class="row" *ngIf="showOjtAssigned">
      <div class="col-xs-12">
          <aims-common-table
          id="job-training-table"
          [dataSource]="otherJobTitleTraining | async"
          [header]="qualificationTableHeader"
          [permissions]="qualificationTablePermissions"
          pageSize="10"
          [stickyHeader]="true">

          <aims-common-table-dynamic-row id="buttons">
            <ng-template viewMode let-element >
              <aims-common-button-mini
                  *ngIf="permissions.canUpdate(permissions.ComponentID.EmployeeTraining) && routedFrom == 'employeeTraining' && !isMyTraining"
                  (click)="updateQualRequired(element, OTHER_JOB_TITLE)"
                  title="Toggle Required"
                  aria-label="Toggle Required">
                <span class="primary-text"> {{ (element.qualRequired) ? '-Req' : '+Req' }}</span>
              </aims-common-button-mini>

              <aims-common-button-mini
                  *ngIf="permissions.canUpdate(permissions.ComponentID.QualApproval) &&
                    element.qualActive &&
                    routedFrom == 'employeeTraining' &&
                    !isMyTraining &&
                    !(element.qualHistory === undefined || element.qualHistory.length == 0) &&
                    element.qualHistory[0].approvedBy != null"
                  (click)="openRevokeApprovalComment(element, OTHER_JOB_TITLE)"
                  title="Revoke Approval"
                  aria-label="Revoke Approval">
                <span class="primary-text">Rev</span>
            </aims-common-button-mini>
          </ng-template>
        </aims-common-table-dynamic-row>

        <aims-common-table-dynamic-row id="approvedOn">
          <ng-template viewMode let-element >
              {{(element.qualHistory === undefined || element.qualHistory.length == 0) ? "" : element.qualHistory[0].approvedOn | date:'MM/dd/yyyy'}}
          </ng-template>
        </aims-common-table-dynamic-row>

        <aims-common-table-dynamic-row id="approvedBy">
          <ng-template viewMode let-element >
              {{(element.qualHistory === undefined || element.qualHistory.length == 0) ? "" : element.qualHistory[0].approvedBy}}
          </ng-template>
        </aims-common-table-dynamic-row>

        <aims-common-table-dynamic-row id="revokedOn">
          <ng-template viewMode let-element >
              {{(element.qualHistory === undefined || element.qualHistory.length == 0) ? "" : element.qualHistory[0].revokedOn | date:'MM/dd/yyyy'}}
          </ng-template>
        </aims-common-table-dynamic-row>

        <aims-common-table-dynamic-row id="revokedBy">
          <ng-template viewMode let-element >
              {{(element.qualHistory === undefined || element.qualHistory.length == 0) ? "" : element.qualHistory[0].revokedBy }}
          </ng-template>
        </aims-common-table-dynamic-row>

        <ng-template aimsCommonTableExpandedRow let-element >
          <div style="flex-wrap: wrap; width:100%">
            <div class="col-md-6" style="width: 100%;">
              <aims-common-table
                    id="general-sub-table"
                    [dataSource]="element.qtDetail"
                    [header]="qualificationSubTableHeader"
                    [permissions]="qualificationSubTablePermissions"
                    pageSize="5"
                    [stickyHeader]="true">

                <aims-common-table-dynamic-row id="buttons">
                  <ng-template viewMode let-element >
                    <aims-common-button-mini
                          *ngIf="permissions.canUpdate(permissions.ComponentID.EmployeeTraining) && routedFrom == 'employeeTraining' && !isMyTraining"
                          (click)="updateQtRequired(element, OTHER_JOB_TITLE)"
                          title="Toggle Required"
                          aria-label="Toggle Required">
                       <span class="primary-text"> {{ (element.qtRequired) ? '-Req' : '+Req' }}</span>
                    </aims-common-button-mini>

                    <aims-common-button-mini *ngIf="permissions.canUpdate(permissions.ComponentID.EmployeeTraining) &&
                                element.qtActive &&
                                routedFrom == 'employeeTraining' &&
                                !isMyTraining &&
                                !element.qtHistory?.revoked &&
                                element.qtHistory?.completedOn != null"
                          (click)="openRevokeComment(element, OTHER_JOB_TITLE)"
                          title="Revoke"
                          aria-label="Revoke">
                       <span class="primary-text">Rev</span>
                    </aims-common-button-mini>

                    <aims-common-button-mini *ngIf="(tFunc.canUpdateTraining(element) &&
                              ( (permissions.canUpdate(permissions.ComponentID.EmployeeTraining) && routedFrom == 'employeeTraining' && !isMyTraining) ||
                                (permissions.canUpdate(permissions.ComponentID.MyTraining) && routedFrom == 'myTraining')))"
                              (click)="updateTraining(element, OTHER_JOB_TITLE)"
                          title="Update"
                          aria-label="Update">
                       <span class="primary-text">Upd</span>
                    </aims-common-button-mini>

                  </ng-template>
                </aims-common-table-dynamic-row>

                <aims-common-table-dynamic-row id="qualTaskUrlLink">
                  <ng-template viewMode let-element >
                    <a *ngIf="element.qualTaskUrlLink != null && element.qualTaskUrlLink.length > 1" target="_blank" style="color:blue" href="{{element.qualTaskUrlLink}}">Go To</a>
                  </ng-template>
                </aims-common-table-dynamic-row>

                <aims-common-table-dynamic-row id="revokedReason">
                  <ng-template viewMode let-element >
                      {{element.qtHistory?.revokedReason}}
                  </ng-template>
                </aims-common-table-dynamic-row>

                <aims-common-table-dynamic-row id="completedOn">
                  <ng-template viewMode let-element >
                    <span class="whole-cell" [ngStyle]="tFunc.colorDate(element.qtHistory?.completedOn, element.intervalInMonths )">
                        {{element.qtHistory?.completedOn | date:'MM/dd/yyyy'}}
                      </span>
                  </ng-template>
                </aims-common-table-dynamic-row>

                <aims-common-table-dynamic-row id="trainedBy">
                  <ng-template viewMode let-element >
                      {{element.qtHistory?.trainedBy}}
                  </ng-template>
                </aims-common-table-dynamic-row>

                <aims-common-table-dynamic-row id="certifiedBy">
                  <ng-template viewMode let-element >
                      {{element.qtHistory?.certifiedBy}}
                  </ng-template>
                </aims-common-table-dynamic-row>
              </aims-common-table>
            </div>
          </div>
        </ng-template>
        </aims-common-table>
      </div>
    </div>
    <hr style="margin-top:2px;margin-bottom:2px" />

    <div class="row colorSection">
      <div class="col-xs-12 text-left">
        <h4>
          <strong><u>Job Assignment</u>&nbsp;&nbsp;  </strong><input style="width: 13px" type="checkbox" name="showJaAssigned" [(ngModel)]="showJaAssigned" tabindex="-1" />
        </h4>
      </div>
    </div>

    <div class="row" *ngIf="showJaAssigned">
      <div class="col-xs-12">
        <aims-common-table
          id="job-assignment-table"
          [dataSource]="jobAssignmentTraining | async"
          [header]="qualificationTableHeader"
          [permissions]="qualificationTablePermissions"
          pageSize="10"
          [stickyHeader]="true">

          <aims-common-table-dynamic-row id="buttons">
            <ng-template viewMode let-element >
              <aims-common-button-mini
                  *ngIf="permissions.canUpdate(permissions.ComponentID.EmployeeTraining) && routedFrom == 'employeeTraining' && !isMyTraining"
                  (click)="updateQualRequired(element, EMP_JOB_ASSIGNMENT)"
                  title="Toggle Required"
                  aria-label="Toggle Required">
                <span class="primary-text"> {{ (element.qualRequired) ? '-Req' : '+Req' }}</span>
              </aims-common-button-mini>

              <aims-common-button-mini
                  *ngIf="permissions.canUpdate(permissions.ComponentID.QualApproval) &&
                    element.qualActive &&
                    routedFrom == 'employeeTraining' &&
                    !isMyTraining &&
                    !(element.qualHistory === undefined || element.qualHistory.length == 0) &&
                    element.qualHistory[0].approvedBy != null"
                  (click)="openRevokeApprovalComment(element, EMP_JOB_ASSIGNMENT)"
                  title="Revoke Approval"
                  aria-label="Revoke Approval">
                <span class="primary-text">Rev</span>
            </aims-common-button-mini>
          </ng-template>
        </aims-common-table-dynamic-row>

        <aims-common-table-dynamic-row id="approvedOn">
          <ng-template viewMode let-element >
              {{(element.qualHistory === undefined || element.qualHistory.length == 0) ? "" : element.qualHistory[0].approvedOn | date:'MM/dd/yyyy'}}
          </ng-template>
        </aims-common-table-dynamic-row>

        <aims-common-table-dynamic-row id="approvedBy">
          <ng-template viewMode let-element >
              {{(element.qualHistory === undefined || element.qualHistory.length == 0) ? "" : element.qualHistory[0].approvedBy}}
          </ng-template>
        </aims-common-table-dynamic-row>

        <aims-common-table-dynamic-row id="revokedOn">
          <ng-template viewMode let-element >
              {{(element.qualHistory === undefined || element.qualHistory.length == 0) ? "" : element.qualHistory[0].revokedOn | date:'MM/dd/yyyy'}}
          </ng-template>
        </aims-common-table-dynamic-row>

        <aims-common-table-dynamic-row id="revokedBy">
          <ng-template viewMode let-element >
              {{(element.qualHistory === undefined || element.qualHistory.length == 0) ? "" : element.qualHistory[0].revokedBy }}
          </ng-template>
        </aims-common-table-dynamic-row>

        <ng-template aimsCommonTableExpandedRow let-element >
          <div style="flex-wrap: wrap; width:100%">
            <div class="col-md-6" style="width: 100%;">
              <aims-common-table
                    id="job-assignment-sub-table"
                    [dataSource]="element.qtDetail"
                    [header]="qualificationSubTableHeader"
                    [permissions]="qualificationSubTablePermissions"
                    pageSize="5"
                    [stickyHeader]="true">

                <aims-common-table-dynamic-row id="buttons">
                  <ng-template viewMode let-element >
                    <aims-common-button-mini
                          *ngIf="permissions.canUpdate(permissions.ComponentID.EmployeeTraining) && routedFrom == 'employeeTraining' && !isMyTraining"
                          (click)="updateQtRequired(element, EMP_JOB_ASSIGNMENT)"
                          title="Toggle Required"
                          aria-label="Toggle Required">
                       <span class="primary-text"> {{ (element.qtRequired) ? '-Req' : '+Req' }}</span>
                    </aims-common-button-mini>

                    <aims-common-button-mini *ngIf="permissions.canUpdate(permissions.ComponentID.EmployeeTraining) &&
                                element.qtActive &&
                                routedFrom == 'employeeTraining' &&
                                !isMyTraining &&
                                !element.qtHistory?.revoked &&
                                element.qtHistory?.completedOn != null"
                          (click)="openRevokeComment(element, EMP_JOB_ASSIGNMENT)"
                          title="Revoke"
                          aria-label="Revoke">
                       <span class="primary-text">Rev</span>
                    </aims-common-button-mini>

                    <aims-common-button-mini *ngIf="(tFunc.canUpdateTraining(element) &&
                              ( (permissions.canUpdate(permissions.ComponentID.EmployeeTraining) && routedFrom == 'employeeTraining' && !isMyTraining) ||
                                (permissions.canUpdate(permissions.ComponentID.MyTraining) && routedFrom == 'myTraining')))"
                              (click)="updateTraining(element, EMP_JOB_ASSIGNMENT)"
                          title="Update"
                          aria-label="Update">
                       <span class="primary-text">Upd</span>
                    </aims-common-button-mini>

                  </ng-template>
                </aims-common-table-dynamic-row>

                <aims-common-table-dynamic-row id="qualTaskUrlLink">
                  <ng-template viewMode let-element >
                    <a *ngIf="element.qualTaskUrlLink != null && element.qualTaskUrlLink.length > 1" target="_blank" style="color:blue" href="{{element.qualTaskUrlLink}}">Go To</a>
                  </ng-template>
                </aims-common-table-dynamic-row>

                <aims-common-table-dynamic-row id="revokedReason">
                  <ng-template viewMode let-element >
                      {{element.qtHistory?.revokedReason}}
                  </ng-template>
                </aims-common-table-dynamic-row>

                <aims-common-table-dynamic-row id="completedOn">
                  <ng-template viewMode let-element >
                    <span class="whole-cell" [ngStyle]="tFunc.colorDate(element.qtHistory?.completedOn, element.intervalInMonths )">
                        {{element.qtHistory?.completedOn | date:'MM/dd/yyyy'}}
                      </span>
                  </ng-template>
                </aims-common-table-dynamic-row>

                <aims-common-table-dynamic-row id="trainedBy">
                  <ng-template viewMode let-element >
                      {{element.qtHistory?.trainedBy}}
                  </ng-template>
                </aims-common-table-dynamic-row>

                <aims-common-table-dynamic-row id="certifiedBy">
                  <ng-template viewMode let-element >
                      {{element.qtHistory?.certifiedBy}}
                  </ng-template>
                </aims-common-table-dynamic-row>
              </aims-common-table>
            </div>
          </div>
        </ng-template>

        </aims-common-table>
      </div>
    </div>
    <hr style="margin-top:2px;margin-bottom:2px" />

  </div>

  <aims-spinner [spinnerText]="spinnerText" [showSpinner]="showSpinner"></aims-spinner>

</div>
